import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[numericOnly]'
})
export class NumericOnlyDirective {
  private static readonly numericKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  private static readonly controlKeys = ['Delete', 'Backspace', 'Tab', 'Escape', 'Enter', ' '];
  private static readonly navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): boolean {
    if (this.isModifierKeyCombo(event) || this.isAllowedKey(event.key)) {
      return true;
    }

    event.preventDefault();
    return false;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;

    const pastedText = clipboardData.getData('text');
    const cleanedText = this.filterNonNumericCharacters(pastedText);

    if (this.hasNonNumericCharacters(pastedText, cleanedText)) {
      event.preventDefault();
      this.insertCleanedText(cleanedText);
    }
  }

  private isModifierKeyCombo(event: KeyboardEvent): boolean {
    return event.metaKey || event.ctrlKey;
  }

  private isAllowedKey(key: string): boolean {
    return this.isNumericKey(key) ||
           this.isControlKey(key) ||
           this.isNavigationKey(key);
  }

  private isNumericKey(key: string): boolean {
    return NumericOnlyDirective.numericKeys.includes(key);
  }

  private isControlKey(key: string): boolean {
    return NumericOnlyDirective.controlKeys.includes(key);
  }

  private isNavigationKey(key: string): boolean {
    return NumericOnlyDirective.navigationKeys.includes(key);
  }

  private filterNonNumericCharacters(text: string): string {
    return text.replace(/[^\d\s,]/g, '');
  }

  private hasNonNumericCharacters(original: string, cleaned: string): boolean {
    return cleaned !== original;
  }

  private insertCleanedText(text: string): void {
    document.execCommand('insertText', false, text);
  }
}
